import shortLogo from '../../media/Balanz_white_shortlogo.svg'
import whiteHomeIcon from '../../media/white_home_icon.svg'
import whiteTag from '../../media/white_tag_icon.svg'
import Profile from '../../media/profile_picture.svg'
import LogOut from '../../media/white_logout_icon.svg'
import bLogo from '../../media/white_b_logo.svg'
import './sidebar.css'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useGlobalContent } from '../../context/helpersProvider'

export const SideBar = (props: any) => {
  const { children } = props
  const history = useNavigate()
  const { setShowToast } = useGlobalContent()
  const clearStorage = () => {
    localStorage.removeItem('a')
    localStorage.removeItem('idClient')
    localStorage.removeItem('emailClient')
    localStorage.removeItem('nameClient')
  }

  const handleLogout = async () => {
    try {
      const res = await axios.post('user/logout')

      if (res.data.status === 200) {
        setShowToast({ open: 'true', type: 'success', message: res.data.message })
      } else {
        setShowToast({ open: 'true', type: 'error', message: res.data.message })
      }
    } catch (err) {
      setShowToast({ open: 'true', type: 'error', message: 'Unable to logout' })
      console.log(err)
    } finally {
      delete axios.defaults.headers.common['Authorization']
      clearStorage()
      history('/')
    }
  }



  return (
    <div className='div-dashboard container'>
      <div className='navbar-div'>
        <span aria-current='page' className='brand w-nav-brand w--current'>
          <img
            loading='lazy'
            width='120'
            height=''
            src={shortLogo}
            alt='Balanz logo'
            className='balanz-logo'
            onClick={()=>history('/home')}
          />
          <img src={bLogo} loading='lazy' width='20' alt='logo' className='b-logo' />
        </span>
        <div className='dashbrd-butns-div'>
          {process.env.REACT_APP_ENABLE_EMAIL_SC == "true" && (
            <Link to='/home' title='Home'>
              <span aria-current='page' className='dashbrd-btn w-inline-block w--current'>
                <img loading='lazy' src={whiteHomeIcon} alt='' className='icon' />
                <div className='dashbrd-text-btns'>Home</div>
              </span>
            </Link>
            )
          }

          {process.env.REACT_APP_ENABLE_EMAIL_SC == "true" && (
            <Link to='/preferences' title='Preferences'>
              <span className='dashbrd-btn w-inline-block'>
                <img src={whiteTag} loading='lazy' alt='' className='icon' />
                <div className='dashbrd-text-btns'>Email Subscription Preferences</div>
              </span>
            </Link>
            )}
        </div>
        <div className='dashbrd-butns-div'>
          <Link to='/user' title='Profile'>
            <span className='dashbrd-btn w-inline-block'>
              <img loading='lazy' src={Profile} alt='Profile' className='profile-image' />
              <div className='dashbrd-text-btns'>
                {localStorage.getItem('nameClient')}
              </div>
            </span>
          </Link>

          <span
            onClick={handleLogout}
            title='Logout'
          >
            <span className='dashbrd-btn logout w-inline-block'>
              <img loading='lazy' src={LogOut} alt='' className='icon' />
              <div className='dashbrd-text-btns'>Logout</div>
            </span>
          </span>
        </div>
      </div>
      <div className='children'>{children}</div>
    </div>
  )
}
